var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full fb fb-cross-center fb-main-center"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noAccess),expression:"noAccess"}],staticClass:"fb-col-center-center c-171A1D-28"},[_vm._m(0),_c('span',{staticClass:"mt-10"},[_vm._v("仅支持管理员、班主任、老师、家长使用")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"iconfont font-100"},[_vm._v("")])])
}]

export { render, staticRenderFns }